<template>
  <v-dialog :model-value="is_open" @update:model-value="updateIsOpen" max-width="400">
    <v-card class="pa-4" style="position: relative;">
      <!-- 右上のCloseボタン -->
      <v-btn
        icon
        class="ma-2"
        style="position: absolute; top: 0; right: 0; z-index: 1;"
        @click="action_close"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <!-- タイトル -->
      <v-card-title class="text-h5 title_pad">{{ title }}</v-card-title>
      <!-- コンテンツ -->
      <v-card-text>
        <slot name="content"></slot>
      </v-card-text>
      <!-- フッター -->
      <v-card-actions class="justify-center" style="gap: 15%;">
        <v-btn color="primary" @click="action_yes">はい</v-btn>
        <v-btn v-if="show_del_btn" color="error" @click="action_del">削除する</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'DialogBase',
  props: {
    is_open: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    show_del_btn: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:is_open', 'action_yes', 'action_close', 'action_del'],
  setup(props, { emit }) {
    const updateIsOpen = (val) => {
      emit('update:is_open', val)
    }

    const action_yes = () => emit('action_yes')
    const action_close = () => emit('update:is_open', false)
    const action_del = () => emit('action_del')

    return {
      updateIsOpen,
      action_yes,
      action_close,
      action_del
    }
  }
}
</script>
